import { useEffect } from 'react';
import type { UseFormSetValue } from 'react-hook-form';
import { hasPartialBalance } from '../../../utils/vacationRules';
import type { VacationBalance } from '../../../models/vacation.types';
import type { VacationRequestFormValues } from '../../../models/vacation.schemas';

export interface UsePartialBalanceModalityParams {
    balance: VacationBalance | null;
    modality: VacationRequestFormValues['modality'];
    setValue: UseFormSetValue<VacationRequestFormValues>;
}

export function usePartialBalanceModality({ balance, modality, setValue }: UsePartialBalanceModalityParams) {
    const isPartialBalance = hasPartialBalance(balance);

    useEffect(() => {
        if (!isPartialBalance) return;
        if (modality !== '30') {
            setValue('modality', '30', { shouldValidate: true });
        }
        setValue('sellDaysRequested', false, { shouldValidate: true });
    }, [isPartialBalance, modality, setValue]);

    return { isPartialBalance };
}
